const testimonials = [
  {
    id: 1,
    name: 'Mariana L.',
    text: 'A Dra. Nathália transformou a minha relação com a saúde íntima. Pela primeira vez me senti verdadeiramente ouvida em uma consulta ginecológica. O ambiente é lindo, acolhedor, e ela explica tudo com muita calma.',
    location: 'Fortaleza - CE',
  },
  {
    id: 2,
    name: 'Carla R.',
    text: 'Coloquei o DIU com a Dra. Nathália e foi uma experiência completamente diferente do que eu imaginava. Ela tem uma delicadeza que acalma na hora. Super recomendo!',
    location: 'Fortaleza - CE',
  },
  {
    id: 3,
    name: 'Beatriz M.',
    text: 'Estava com muito receio da menopausa e ela me acolheu de uma forma tão humana. A reposição hormonal que ela indicou mudou minha qualidade de vida. Sou grata demais.',
    location: 'Fortaleza - CE',
  },
  {
    id: 4,
    name: 'Fernanda S.',
    text: 'O laser íntimo foi um divisor de águas pra mim. A Dra. Nathália é extremamente profissional e cuidadosa. Resultado incrível e sem dor. Que alívio ter encontrado uma médica assim.',
    location: 'Eusébio - CE',
  },
  {
    id: 5,
    name: 'Juliana P.',
    text: 'Desde a primeira consulta me senti em casa. O atendimento é impecável, a clínica é linda e ela é uma médica que realmente se importa. Minha saúde nunca esteve tão em dia.',
    location: 'Fortaleza - CE',
  },
  {
    id: 6,
    name: 'Amanda C.',
    text: 'Fiz o preventivo com ela e foi a experiência mais tranquila que já tive. Ela consegue transformar um exame que geralmente é desconfortável em algo leve. Profissionalismo e doçura na medida certa.',
    location: 'Fortaleza - CE',
  },
];

export default function TestimonialsSection() {
  const animationDelays = ['0s', '0.4s', '0.8s', '0.2s', '0.6s', '1.0s'];
  const animationDurations = ['6s', '7s', '5.5s', '7.5s', '6.5s', '5s'];

  return (
    <section id="depoimentos" data-cascade className="relative w-full py-28 md:py-44 bg-nude paper-texture overflow-hidden">
      {/* Depth blurs */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-[15%] left-[-3%] w-[30%] h-[45%] rounded-full bg-rose-light/8 blur-[120px]" />
        <div className="absolute bottom-[10%] right-[-5%] w-[28%] h-[40%] rounded-full bg-sage-light/6 blur-[100px]" />
      </div>

      <div className="relative max-w-[1050px] mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="text-center mb-16 md:mb-24">
          <p data-cascade-label className="font-body text-[10px] md:text-[11px] text-secondary-500 tracking-[0.4em] uppercase mb-3">
            Depoimentos
          </p>
          <div data-cascade-line className="w-12 h-[1px] bg-gold-matte/40 mx-auto mb-4" />
          <h2 data-cascade-title className="font-heading text-2xl md:text-3xl lg:text-4xl text-graphite font-light">
            O que as{' '}
            <span className="italic">pacientes</span> dizem.
          </h2>
        </div>

        {/* Floating cards grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {testimonials.map((item, index) => (
            <div
              key={item.id}
              data-slide-in
              data-slide-direction={index % 2 === 0 ? 'left' : 'right'}
              className="group relative bg-white/70 backdrop-blur-sm border border-white/50 p-8 md:p-10 transition-all duration-500 ease-out hover:bg-white/95 hover:border-gold-matte/15 hover:scale-[1.02] hover:shadow-[0_8px_40px_rgba(0,0,0,0.03)]"
              style={{
                animation: `floatCard${index % 2 === 0 ? 'Slow' : ''} ${animationDurations[index]} ${animationDelays[index]} ease-in-out infinite`,
                transform: `translateY(${index % 2 === 0 ? '4px' : '-2px'})`,
              }}
            >
              {/* Quote mark */}
              <div className="absolute top-6 right-8 text-6xl font-heading text-gold-matte/10 leading-none select-none">
                &ldquo;
              </div>

              <p className="font-body text-sm text-graphite/65 leading-[1.8] font-light mb-7 relative z-10">
                {item.text}
              </p>

              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-rose-light/50 flex items-center justify-center">
                  <span className="font-heading text-sm text-graphite/55">
                    {item.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="font-body text-xs text-graphite/75 font-medium">{item.name}</p>
                  <p className="font-body text-[11px] text-secondary-500">{item.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}